import { render } from "./allService.vue?vue&type=template&id=7350b6bd"
import script from "./allService.vue?vue&type=script&lang=js"
export * from "./allService.vue?vue&type=script&lang=js"

import "./allService.vue?vue&type=style&index=0&id=7350b6bd&lang=css"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__